<template>
    <div class="details-modal" v-if="data">
        <div class="content">
            <a class="icon-close" @click="onClose">
                <Icon type="ios-close" size="48"/>
            </a>
            <div class="public-article-title">
                <h1>{{ data.title }}</h1>
                <h6>
                    <span class="plr-sm d-none">{{ lang === 'zh-cn' ? '作者' : 'Author' }}：{{ data.author }}</span>
                    <span class="plr-sm d-none">{{ lang === 'zh-cn' ? '发布时间' : 'Send Time' }}：{{ data.updateTime }}</span>
                </h6>
            </div>
            <br/>
            <div class="d-flex-item scrollbar">
                <h1>{{ data.decs }}</h1>
                <div class="d-block ptb-xl" v-if="data.video && data.video.enable === true">
                    <div class="d-block pb-lg align-center">
                        <h1 class="size-24">{{ data.video.title }}</h1>
                        <h2>{{ data.video.introduction }}</h2>
                    </div>
                    <video-player ref="videoPlayer" v-bind:data="data.video.video" style="height: 768px;"/>
                </div>
                <div class="d-block" data-box="article-content" v-html="data.content"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .details-modal{
        position: fixed;
        box-sizing: content-box;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 9999;
    }
    .details-modal:before{
        content: '';
        position: absolute;
        box-sizing: content-box;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .5);
        z-index: -1;
    }
    .details-modal .content{
        display: flex !important;
        display: -webkit-flex !important;
        flex-direction: column;
        box-sizing: border-box;
        position: relative;
        width: 1170px;
        height: 100%;
        padding: 48px;
        margin: auto;
        background: #fff;
    }
    .details-modal .icon-close{
        position: absolute;
        right: 11px;
        top: 11px;
        color: #FB6463;
    }
</style>

<script type="text/javascript">
    import VideoPlayer from "./VideoPlayer";

    export default {
        components: {
            VideoPlayer
        },
        data () {
            return {
            }
        },
        props: ['lang', 'data'],
        mounted() {
            if (this.data) {
                console.log('接收：---------->');
                console.log(this.data);
            }
        },
        methods: {
            onClose(){
                this.$emit('actions', false);
                // 如果：有视频 则 关闭时候销毁
                if (this.data.video.enable === true){
                    this.$refs.videoPlayer.__dispose();
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/DetailsModal.vue